export default {
    ListLoading: 'index:index:ListLoading', // 流加载
    INDEXLIST: 'index:index:indexList', // 获取列表
    TODYTASK:'index:index:todyTask', //今日任务
    NOMALAGENTCONNINFO:'index:index:nomalAgentConnInfo',
    PHONEAGENTCONNINFO:'index:index:phoneAgentConnInfo',
    AGENT:'index:index:agentMinotor',// 代理监控
    TASKLOADING:'index:index:TaskLoading',//任务监控loading
    TASK:'index:index:taskMinotor',// 任务监控
    SERVICE:'index:index:service',// 服务监控
    DISCARD: 'index:index:discard', // 废弃监控
    TASKINDEXLIST: 'index:taskList:excute',//任务到达率互动率平均停留时间
};



// WEBPACK FOOTER //
// ./pages/index/constant.js